export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.1-1457.35",
  commitId: "c0354cb72f9325bcbb28be44dd8c59441ab0de1f",
  commitTime: "2026-05-01T14:57:35.000Z",
});
